export var siteType = {
    WIND: 0,
    SOLAR: 1,
    HYGRO: 2,
    BIOGAZ: 3,
    ALL: 4
  };